import Navbar from './Navbar';
import Footer from './Footer';
import PageHero from './PageHero';
import ProductCard from './ProductCard';
import Formular from './Formular';
import { ScrollRestoration } from 'react-router-dom';
import piesok01 from '../resources/Piesok 0-1.jpeg';
import piesok02 from '../resources/Piesok 0-2.jpeg';

const items = [
    'Frakcia 0/1 Piesok',
    'Frakcia 0/2 Piesok',
];

const cards = [
    {
        img: piesok01,
        badge: 'Piesok',
        title: 'Frakcia 0/1',
        description: 'Vhodný na betón, murovacie malty, omietky a špárovanie zámkovej dlažby.',
        tableRows: [{ label: 'Cena za t', bezDph: '20,81 €', sDph: '25,60 €' }],
    },
    {
        img: piesok02,
        badge: 'Piesok',
        title: 'Frakcia 0/2',
        description: 'Vhodný na betón, murovacie malty, omietky a špárovanie zámkovej dlažby.',
        tableRows: [{ label: 'Cena za t', bezDph: '19,11 €', sDph: '23,50 €' }],
    },
];

function Piesok() {
    return (
        <div>
            <Navbar />
            <PageHero
                title="Naša"
                highlight="ponuka"
                subtitle="Jemné piesky ideálne pre malty, betóny a omietky."
            />
            <div className="max-w-3xl mx-auto px-6 py-14 grid grid-cols-1 sm:grid-cols-2 gap-8">
                {cards.map((card, i) => (
                    <ProductCard key={i} {...card} />
                ))}
            </div>
            <Formular napln={items} />
            <Footer />
            <ScrollRestoration />
        </div>
    );
}

export default Piesok;
